import React, { useState, useRef, useEffect, useCallback } from "react";
import Wheel from "@uiw/react-color-wheel";
import { hsvaToHex } from "@uiw/color-convert";
import { GetColorName } from "hex-color-to-color-name";
import { AiOutlineDown, AiOutlineUp } from "react-icons/ai";
import { useNavigate } from "react-router-dom";

const GiftWrappingPaper = ({
  stateChanger,
  data,
  save,
  state,
  otherColors,
}) => {
  const navigate = useNavigate();
  const [hsva, setHsva] = useState({ h: 214, s: 43, v: 90, a: 1 });
  const [hex, setHex] = useState(data.t1Color);
  const [colorWheelVisible, setColorWheelVisible] = useState(false);
  const colorWheelContainerRef = useRef(null);

  const [hsva2, setHsva2] = useState({ h: 214, s: 43, v: 90, a: 1 });
  const [hex2, setHex2] = useState(data.t2Color);
  const [colorWheelVisible2, setColorWheelVisible2] = useState(false);
  const colorWheelContainerRef2 = useRef(null);

  useEffect(() => {
    const hexColor = hsvaToHex(hsva);
    if (data.t1Color == hexColor) return;
    setHex(hexColor);
    stateChanger("t1Color", hex);
  }, [hsva]);

  useEffect(() => {
    const hexColor = hsvaToHex(hsva2);
    if (data.t2Color == hexColor) return;
    setHex2(hexColor);
    stateChanger("t2Color", hex2);
  }, [hsva2]);

  const handleLabelClick = (e) => {
    // Prevent the click event from reaching the document level
    e.stopPropagation();

    // Toggle the visibility of the color wheel
    setColorWheelVisible(!colorWheelVisible);
  };

  const handleLabelClick2 = (e) => {
    // Prevent the click event from reaching the document level
    e.stopPropagation();

    // Toggle the visibility of the color wheel
    setColorWheelVisible2(!colorWheelVisible2);
  };

  const handleDocumentClick = (e) => {
    if (
      colorWheelVisible &&
      colorWheelContainerRef.current &&
      !colorWheelContainerRef.current.contains(e.target)
    ) {
      setColorWheelVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [colorWheelVisible]);

  const handleDocumentClick2 = (e) => {
    if (
      colorWheelVisible2 &&
      colorWheelContainerRef2.current &&
      !colorWheelContainerRef2.current.contains(e.target)
    ) {
      setColorWheelVisible2(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleDocumentClick2);

    return () => {
      document.removeEventListener("click", handleDocumentClick2);
    };
  }, [colorWheelVisible2]);

  useEffect(() => {
    colorWheelVisible && setColorWheelVisible2(false);
    colorWheelVisible2 && setColorWheelVisible(false);
    (!colorWheelVisible || !colorWheelVisible2) && setIsActive(false);
  }, [colorWheelVisible, colorWheelVisible2]);

  const colors = [
    // { title: "Select Colour", color: "#013322" },
    { title: "White", color: "#fff" },
    { title: "Black", color: "#000" },
    { title: "Gold", color: "#c9a401" },
    { title: "Silver", color: "#c0c0c0" },
    { title: "Dark Grey", color: "#404040" },
    { title: "Navy", color: "#000060" },
    { title: "Teal", color: "#008080" },
    { title: "Green", color: "#05bb68" },
    { title: "Purple", color: "#8458f7" },
    { title: "Linen", color: "#c3bdb1" },
    { title: "Sand", color: "#C0AA79" },
    { title: "Copper", color: "#b97c5f" },
    { title: "Steel Blue", color: "#2f3d62" },
    { title: "Slate Grey", color: "#9e988c" },
    { title: "Pewter", color: "#af7148" },
    { title: "Sage", color: "#629278" },
    { title: "Beige", color: "#aba58b" },
    { title: "Rose", color: "#ce9ca7" },
    { title: "Maroon", color: "#7f1722" },
    { title: "Taupe", color: "#849e9b" },
    { title: "Olive", color: "#97916f" },
    { title: "Burgundy", color: "#9e5e6e" },
    { title: "Brick", color: "#8f2434" },
    { title: "Army", color: "#4f5241" },
    { title: "Khaki", color: "#7f755a" },
    { title: "Stone", color: "#9a9c8f" },
    { title: "Plum", color: "#633a58" },
    { title: "Evergreen", color: "#2d4340" },
    { title: "Hazel", color: "#837457" },
    { title: "Chocolate", color: "#5b4f3f" },
    { title: "Black", color: "#352629" },
    { title: "Midnight", color: "#20242d" },
    { title: "Drab", color: "#6f582c" },
    { title: "Azure", color: "#1e6da6" },
    { title: "Charcoal", color: "#363739" },
    { title: "Jet Black", color: "#202020" },
  ];

  const [isActive, setIsActive] = useState(false);
  const [selected, setIsSelected] = useState("Select Colour");
  const [selected2, setIsSelected2] = useState("Select Colour");

  return (
    <>
      <div className=" flex flex-col justify-center gap-5 ">
        <h2 className="text-[24px]" style={{ fontFamily: "ZapfHumanistBold" }}>
          TISSUE PAPER
        </h2>
        <p className="text-[14px] mt-[-12px]">
          Our tissue paper is available in 7 sizes and range from 17-28gsm. We
          print up to two Pantone colours and full colour CMYK. Showcased here
          is our most popular size 380x500mm. FSC-certified, recycled paper and
          is fully home-compostable after use.
        </p>
        <div className="flex items-center">
          <div className="relative">
            <p
              className="text-[16px] mb-2 mt-8"
              style={{ fontFamily: "ZapfHumanistBold" }}
            >
              Tissue Option #1
            </p>
            <label
              htmlFor="t1ColorPicker"
              className="bg-white w-[200px] flex flex-row items-center justify-between px-5 py-2 rounded cursor-pointer"
              onClick={handleLabelClick}
            >
              <p>{GetColorName(data.t1Color)} &nbsp;</p>
              <div
                className="w-[20px] h-[20px] border-2"
                style={{ backgroundColor: data.t1Color }}
              ></div>
            </label>
            <span
              className="text-[12px] m-2"
              style={{ fontFamily: "ZapfHumanistBold" }}
            >
              *Click on colour to change*
            </span>
            {/* <input
              className="absolute opacity-0"
              type="color"
              id="t1ColorPicker"
              name="t1ColorPicker"
              onChange={(e) => {
                stateChanger("t1Color", e.target.value);
              }}
            /> */}
          </div>
        </div>
        <div className="flex items-center">
          <div className="relative">
            <p
              className="text-[16px] mb-2"
              style={{ fontFamily: "ZapfHumanistBold" }}
            >
              Tissue Option #2
            </p>
            <label
              htmlFor="t2ColorPicker"
              className="bg-white w-[200px] flex flex-row items-center justify-between px-5 py-2 rounded cursor-pointer"
              onClick={handleLabelClick2}
            >
              <p>{GetColorName(data.t2Color)} &nbsp;</p>
              <div
                className="w-[20px] h-[20px] border-2"
                style={{ backgroundColor: data.t2Color }}
              ></div>
            </label>
            <span
              className="text-[12px] m-2"
              style={{ fontFamily: "ZapfHumanistBold" }}
            >
              *Click on colour to change*
            </span>
          </div>
        </div>

        {/* </div> */}
        <div className="flex gap-2">
          <button
            style={{ fontFamily: "ZapfHumanistBold" }}
            className="bg-red-500 hover:bg-[#02595A] text-white px-3 py-2 mt-8 rounded-full text-[18px] w-[165px] focus:border border-[#0F0F0F] border-solid transition-transform duration-300 hover:scale-110"
            onClick={save}
          >
            SAVE PROGRESS
          </button>
          <button
            style={{ fontFamily: "ZapfHumanistBold" }}
            className="bg-red-500 hover:bg-[#02595A] text-white px-3 py-2 mt-8 rounded-full text-[18px] w-[165px] focus:border border-[#0F0F0F] border-solid transition-transform duration-300 hover:scale-110"
            onClick={() => {
              navigate("/form", { state });
            }}
          >
            SKIP TO END
          </button>
        </div>
        {colorWheelVisible && ( // Render color wheel only if visible
          <div
            ref={colorWheelContainerRef}
            className="mt-4 z-1000 ml-[200px] mt-[-450px] bg-white rounded-[20px] w-[260px] p-6 cursor-pointer flex flex-col gap-2 h-[400px]"
          >
            <p className="mb-4" style={{ fontFamily: "ZapfHumanistBold" }}>
              COLOUR PICKER
            </p>
            <div className="mx-auto">
              <Wheel
                color={hsva}
                onChange={(color) => setHsva({ ...hsva, ...color.hsva })}
              />
              {/* <select
                className="bg-[#F5F5F5] w-[200px] flex flex-row items-center justify-between px-5 py-2 rounded cursor-pointer mt-4"
                onChange={(event) =>
                  stateChanger("t1Color", event.target.value)
                }
              >
                {colors.map((value, index) => {
                  return (
                    <option value={value.color} key={index}>
                      <div>{value.title}</div>
                      <div
                        className="w-[20px] h-[20px] border"
                        style={{ backgroundColor: value.color }}
                      ></div>
                    </option>
                  );
                })}
              </select> */}
              <div
                onClick={(e) => {
                  setIsActive(!isActive);
                }}
                className="bg-[#F5F5F5] w-[200px] flex flex-row items-center justify-between px-5 py-2 rounded cursor-pointer mt-4 mb-2"
              >
                {selected}
                {/* <span>{isActive ? <AiOutlineUp /> : <AiOutlineDown />}</span> */}
                <span>
                  <AiOutlineDown />
                </span>
              </div>
              <div
                className="dropdown-content"
                style={{ display: isActive ? "block" : "none" }}
              >
                {colors.map((value, index) => {
                  return (
                    <div
                      onClick={(e) => {
                        setIsSelected(value.title);
                        setIsActive(!isActive);
                        stateChanger("t1Color", value.color);
                      }}
                      key={index}
                      className="item"
                    >
                      <div>{value.title}</div>
                      <div
                        className="w-[20px] h-[20px] border-2"
                        style={{ backgroundColor: value.color }}
                      ></div>
                    </div>
                  );
                })}
              </div>
              <label
                className="py-2"
                style={{ fontFamily: "ZapfHumanistBold" }}
              >
                Recently Selected Colours
              </label>
              <ul className="mt-3 ml-1 h-5">
                {otherColors.map((color) => (
                  <li
                    className="w-5 h-[100%] float-left mr-2 cursor-pointer border-2"
                    onClick={(e) => {
                      // setIsSelected(value.title);
                      // setIsActive(!isActive);
                      stateChanger("t1Color", color);
                    }}
                    style={{ backgroundColor: color }}
                  ></li>
                ))}
              </ul>
            </div>
          </div>
        )}
        {colorWheelVisible2 && ( // Render color wheel only if visible
          <div
            ref={colorWheelContainerRef2}
            className="mt-4 z-1000 ml-[200px] mt-[-350px] bg-white rounded-[20px] w-[260px] p-6 cursor-pointer flex flex-col gap-2 h-[400px]"
          >
            <p className="mb-4" style={{ fontFamily: "ZapfHumanistBold" }}>
              COLOUR PICKER
            </p>
            <div className="mx-auto">
              <Wheel
                color={hsva2}
                onChange={(color) => setHsva2({ ...hsva2, ...color.hsva })}
              />
              {/* <select
                className="bg-[#F5F5F5] w-[200px] flex flex-row items-center justify-between px-5 py-2 rounded cursor-pointer mt-4"
                onChange={(event) =>
                  stateChanger("t2Color", event.target.value)
                }
              >
                {colors.map((value, index) => {
                  return (
                    <option value={value.color} key={index}>
                      <div>{value.title}</div>
                      <div
                        className="w-[20px] h-[20px] border"
                        style={{ backgroundColor: value.color }}
                      ></div>
                    </option>
                  );
                })}
              </select> */}
              <div
                onClick={(e) => {
                  setIsActive(!isActive);
                }}
                className="bg-[#F5F5F5] w-[200px] flex flex-row items-center justify-between px-5 py-2 rounded cursor-pointer mt-4 mb-2"
              >
                {selected2}
                {/* <span>{isActive ? <AiOutlineUp /> : <AiOutlineDown />}</span> */}
                <span>
                  <AiOutlineDown />
                </span>
              </div>
              <div
                className="dropdown-content"
                style={{ display: isActive ? "block" : "none" }}
              >
                {colors.map((value, index) => {
                  return (
                    <div
                      onClick={(e) => {
                        setIsSelected2(value.title);
                        setIsActive(!isActive);
                        stateChanger("t2Color", value.color);
                      }}
                      key={index}
                      className="item"
                    >
                      <div>{value.title}</div>
                      <div
                        className="w-[20px] h-[20px] border-2"
                        style={{ backgroundColor: value.color }}
                      ></div>
                    </div>
                  );
                })}
              </div>
              <label
                className="py-2"
                style={{ fontFamily: "ZapfHumanistBold" }}
              >
                Recently Selected Colours
              </label>
              <ul className="mt-3 ml-1 h-5">
                {otherColors.map((color) => (
                  <li
                    className="w-5 h-[100%] float-left mr-2 cursor-pointer border-2"
                    onClick={(e) => {
                      // setIsSelected(value.title);
                      // setIsActive(!isActive);
                      stateChanger("t2Color", color);
                    }}
                    style={{ backgroundColor: color }}
                  ></li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default GiftWrappingPaper;
